import { render, staticRenderFns } from "./EditLinkPopover.vue?vue&type=template&id=4ed0d0fe&scoped=true"
import script from "./EditLinkPopover.js?vue&type=script&lang=js&external"
export * from "./EditLinkPopover.js?vue&type=script&lang=js&external"
import style0 from "./EditLinkPopover.scss?vue&type=style&index=0&id=4ed0d0fe&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ed0d0fe",
  null
  
)

export default component.exports